// extracted by mini-css-extract-plugin
export default {"headPoster":"index_headPoster_iGIgk"};